import { render } from "./WhoWeWorkWith.vue?vue&type=template&id=2516943a"
import script from "./WhoWeWorkWith.vue?vue&type=script&lang=js"
export * from "./WhoWeWorkWith.vue?vue&type=script&lang=js"

import "./WhoWeWorkWith.vue?vue&type=style&index=0&id=2516943a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__